// extracted by mini-css-extract-plugin
export var chatHtmlText = "_pl-2";
export var chatLink = "_pl-0";
export var chatText = "_pl-1";